import { render, staticRenderFns } from "./StationShow.vue?vue&type=template&id=18abb6cf&scoped=true&"
import script from "./StationShow.vue?vue&type=script&lang=ts&"
export * from "./StationShow.vue?vue&type=script&lang=ts&"
import style0 from "./StationShow.vue?vue&type=style&index=0&id=18abb6cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18abb6cf",
  null
  
)

export default component.exports